import "../styles/top.scss";

// ------------------------------------------
// MV Animations
// ------------------------------------------
document.addEventListener('DOMContentLoaded', () => {
    const texts = document.querySelectorAll('.js-text');

    const charDelay = 0.16;   // 1文字ごとの間隔（秒）
    const fadeDur  = 1;     // 1文字のフェイド時間（秒）※CSSと合わせる
    const gapAfterLine = 0.28; // 行間の余韻（秒）必要なら 0.1 など

    let lineDelay = 0;

    texts.forEach(textEl => {
    const text = textEl.textContent;
    textEl.textContent = '';

    [...text].forEach((char, index) => {
        const span = document.createElement('span');
        span.textContent = char;
        span.style.transitionDelay = `${lineDelay + index * charDelay}s`;
        textEl.appendChild(span);
    });

    // 「この行が完全に表示し終わる」まで待つ
    // 最後の文字が開始する delay = (len-1)*charDelay
    // 完了 = その delay + fadeDur
    const lineTotal = (Math.max(text.length - 1, 0) * charDelay) + fadeDur + gapAfterLine;
    lineDelay += lineTotal;
    });

    const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
        if (
        mutation.attributeName === 'class' &&
        mutation.target.classList.contains('is-active')
        ) {
        mutation.target
            .querySelectorAll('.js-text')
            .forEach(el => el.classList.add('is-active'));
        }
    });
    });

    document.querySelectorAll('.js-trigger').forEach(trigger => {
    observer.observe(trigger, { attributes: true });
    });
});